import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import '../../styles/Comments.css';

const CommentDetailsManager = ({ comment, t, handleDownload }) => {
  return (
    <>
      {/* --- SEÇÃO DE INFORMAÇÕES DO COMENTÁRIO --- */}
      <div className="mb-2">
        <strong>"{comment.text}"</strong>
      </div>

      <div className="d-flex flex-wrap gap-2 mb-2">
        {/* Badge para o número da página */}
        {comment.pageNumber && (
          <Badge bg="secondary" className="align-content-center">{t.pageNumber}: {comment.pageNumber}</Badge>
        )}

        {/* Badge para o tipo de sugestão */}
        {comment.sugestionType && (
          <Badge bg="info" pill={true} className="align-content-center">{comment.sugestionType}</Badge>
        )}

        {(comment.state === "DELETED_FOR_IA" || comment.state === "DELETED_BOOK_OWNER") && (
          <>
            <Badge bg="info" pill={true} className="align-content-center">{comment.state === "DELETED_FOR_IA" ? t.deletedByIA : t.deletedByEditor}</Badge>
          </>
        )}
      </div>

      {/* --- SEÇÃO DE METADADOS E BOTÕES NA MESMA LINHA --- */}
      <div className="d-flex align-items-center gap-2 mb-2">
        {/* Metadados (criador, data) */}
        <div className="text-muted small">
          <strong>{t.createdBy}:</strong> {comment.creator?.name || comment.creator?.username} - {new Date(comment.createdAt).toLocaleString()}
        </div>

        {/* Botão de Download da imagem anexada */}
        {comment.imageBase64 && comment.nameImageBase64 && (
          <div className="d-flex gap-2">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => handleDownload(comment.imageBase64, comment.nameImageBase64)}
            >
              {t.download}: "{comment.nameImageBase64}"
            </Button>
          </div>
        )}
      </div>

      {/* --- SEÇÃO DE CAPÍTULO --- */}
      {comment.chapter && (
        <div className="text-muted small mb-2">
          <strong>{t.chapter}:</strong> {comment.chapter.title}
          {comment.chapter.book && (
            <span> ({comment.chapter.book.title})</span>
          )}
        </div>
      )}
    </>
  );
};

export default CommentDetailsManager;
